import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { getSelectedModelFactorID, getModelFactorsForUser } from 'quick-quote/product-common/coverage-plan/selectors'
import { selectModelFactor } from 'quick-quote/product-common/coverage-plan/actions'

export const ModelFactorSelection = ({ modelFactors, selectedModelFactorID, selectModelFactor }) => {
  return (
    <div className="form-group" data-testid="basic-plan-model-factor-selection">
      <div className="form-group-title">
        <span className="form-group-title-text">งวดการชำระเบี้ยประกันภัย</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="id"
        className="model-factor"
        onChange={selectModelFactor}
        value={selectedModelFactorID}
        options={modelFactors}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  modelFactors: getModelFactorsForUser(state),
  selectedModelFactorID: getSelectedModelFactorID(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectModelFactor: bindActionCreators(selectModelFactor, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModelFactorSelection)
